<template>
  <div class="informationManage tab-resetStyle div-layout">
    <!-- <router-view /> -->
    <el-tabs v-model="activeName">
      <el-tab-pane label="新闻内容管理" name="content">
        <NewsContentManage />
      </el-tab-pane>
      <el-tab-pane label="新闻类型管理" name="type">
        <NewsTypeManage />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import NewsContentManage from './newsContentManage/index.vue';
import NewsTypeManage from './newsTypeManage/index.vue';
export default {
  name: 'NewsManage',
  components: {
    NewsContentManage,
    NewsTypeManage
  },
  data: () => {
    return {
      activeName: 'content'
    };
  }
};
</script>
